import { notification } from 'antd'
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from 'configs/AppConfig'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import JwtAuthService from 'services/JwtAuthService'

function EmailVerify() {
   const {token}=useParams()
   const [status,setStatus]=useState('pending')
   const verifyEmail=()=>{
       JwtAuthService.verifyEmail({token})
       .then(resp => {
            console.log(resp)
           setStatus('success')
       })
       .catch(error => {
          if(error.response.data === 'expired'){
              setStatus('failure')
          }else{
              notification.error(error.response.data)
          }
       })
    //    try{
    //        const res = await JwtAuthService.verifyEmail(token)
    //        console.log(res)
    //    }catch(error){
    //        console.log(error)
    //    }
   }
   useEffect(()=>{
      verifyEmail()
   },[])
   
    return (
        <>
          <section className='email-verify'>
              <div className='verify-wrapper'>
       
                            {
                                status === "pending" &&
                                <p>
                                    Verifying....
                                </p>
                            }
                            {
                                status === "success" && 
                                <div className='msg'>
                                    <div className='img-holder'>
                                         <img src='/img/success.gif' />
                                    </div>
                                    <p>
                                        Verification successful
                                    </p>
                                    <div className='d-flex justify-content-center'>
                                        <a className='custom-btn d-inline-block mt-4' href={`${AUTH_PREFIX_PATH}`}>
                                            Go To Login
                                        </a>
                                    </div>    
                                </div>
                            }
                            {
                                status === "failure" && 
                                <div className='msg'>
                                    <div className='img-holder'>
                                         <img src='/img/failure.gif' />
                                    </div>
                                    <p>
                                        Token expired
                                    </p>
                                    <div className='d-flex justify-content-center'>
                                        <a className='custom-btn d-inline-block mt-4' href={`${APP_PREFIX_PATH}`}>
                                            Go To Home
                                        </a>
                                    </div>  
                                </div>    
                            }

                  </div>
  


          </section>
        </>
    )
}

export default EmailVerify